(function($) {
	formHelper.addRule({
		form: '.form-account-register',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			},
			ERROR_MESSAGE_ONE: function() {
				if(this.data.systemMessage1) {
					$('#system-message-1').html(this.data.systemMessage1);
				}
			},
			ERROR_MESSAGE_TWO: function() {
				if(this.data.systemMessage2) {
					$('#system-message-2').html(this.data.systemMessage2);
				}
			},
			ERROR_MESSAGE_THREE: function() {
				if(this.data.systemMessage3) {
					$('#system-message-3').html(this.data.systemMessage3);
				}
			},
			ERROR_MESSAGE_FOUR: function() {
				if(this.data.systemMessage4) {
					$('#system-message-4').html(this.data.systemMessage4);
				}
			},
			ERROR_MESSAGE_FIVE: function() {
				if(this.data.systemMessage5) {
					$('#system-message-5').html(this.data.systemMessage5);
				}
			}
		}
	});
})(jQuery);

// Shared functionality below - form fields can be found at /myaccount/templatesInstallation.xsl
jQuery(function initHandleAccountRegisterForm($) {

	$('.form-installation-wrapper').each(function(index, el) {

		var previouslySelectedOption = $('#account-installation').val();

		var initializeInstallations = function() {

			checkInstallation();
		};

		var checkInstallation = function() {

			// AJAX call to load the passed in Branch Name to display installation Reference values / Installation Number
			var id = $('.js-account-branch-action').val();
			previouslySelectedOption = $('#account-installation').val();
			$('#account-installation').prop('disabled', true);

			$.ajax({
				method: 'POST',
				url: '/h/myaccount/getInstallationOptionsByBranch',
				dataType: 'html',
				data: { id: id },
			})
			.done(function( data ) {

				$('#account-installation').html(data);
				$('#account-installation').prop('disabled', false);

				if (previouslySelectedOption !== '' && $("#account-installation option[value='" + previouslySelectedOption + "']").length > 0) {
					$("#account-installation option[value='" + previouslySelectedOption + "']").prop('selected', true);
					var selectedValue = $('#account-installation option:selected').text();
					$('#account-installation-ref').val(selectedValue);
				}
			})
			.fail(function() {

				alert( "An unexpected error has occurred." );
				$('#account-installation').prop('disabled', false);
			});
		};
		
		$('.js-account-branch-action').change(function() {

			checkInstallation();
		});

		$('#account-installation').change(function() {

			// Pull the select selected list value and put into hidden text box for submission
			if($(this).val() !== '') {
				var selectedValue = $('#account-installation option:selected').text();
				$('#account-installation-ref').val(selectedValue);
			}
		});

		// Only initialize the form to check account branch for sites with branches
		var initialBranchValue = $('#account-branch').val();

		if (initialBranchValue !== 'N') {

			initializeInstallations();
		}
	});

	$('#form-add-account-register').each(function(index, el) {

		var $container = $(this);
		var $submitBtn = $container.find('.btn-submit');

		$submitBtn.click(function() {

			var submitCheck = true;

			$('.js-fh-error-grecaptcha-error').css('display','none');

			var response = grecaptcha.getResponse();

			$.ajax({
				method: "POST",
				url: "/h/site/VerifyReCaptchaResponse",
				async: false, // necessary to ensure the AJAX completes (potentially setting 'submitCheck') before submitting the form to salesforce
				data: { reCaptchaResponse: response }
			})
			.done(function( data ) {
				
				var dataJSON = JSON.parse(data);

				if (dataJSON !== '') {

					if (dataJSON.type === 'failure') {

						 $('.js-fh-error-grecaptcha-error').css('display','block');
						 submitCheck = false;
					}
				}
			});

			if (submitCheck) {

				grecaptcha.reset();

				return true;
			}
			else {

				grecaptcha.reset();

				return false;
			}
		});
	});
});